import { createRoot } from 'react-dom/client';
import { NavigationType, RouterProvider } from 'react-router-dom';
import { store } from '@store/store';
import { Provider } from 'react-redux';
import { useOption } from '@hooks/useOption';
import { validateOption } from '@utils/index';
import { setRouter } from './Router';
import { setIsHistoryBack } from '@features/ui/UiSlice';

export const searchApp = (options?: IOption) => {
  const container = document.querySelector('#nc-search');
  const root = createRoot(container as Element);
  const option = useOption(options);
  const isValidate = validateOption(option);
  const router = setRouter(store, option);

  router.subscribe((state) => {
    if (state.historyAction === NavigationType.Pop) {
      store.dispatch(setIsHistoryBack(true));
    }
  });

  if (isValidate) {
    root.render(
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
    );
  }
};

window.ncSearchV2 = searchApp;
